import React, { Component } from 'react';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import 'reactjs-popup/dist/index.css';
import global from '../global'
import { Card, Row, Col, InputGroup, FormControl } from 'react-bootstrap';


export class Error404 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            
            loading: false
        };
        this.initialState = this.state;

    }


    render() {
       
        return (
            <div className="container-login100 banner_area">
             
                <div className="container box_1620">
                    <div className="formDiv">
                        <div className="m-t-20 m-b-20">
                            <Row>
                                <Col md={12}>
                                    <h2 className="text-center text-black">404</h2><br/>
                                </Col>
                                <Col md={12}>
                                    <h3 className="text-center text-black">THE PAGE CANNOT BE FOUND</h3>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>

        );
    }


}